import { type Signal, useComputed } from "@suse-o11y/signal";
import React from "react";

import type { MetricQuery } from "~/models/metric-query";
import type { Time } from "~/tools/date-time/time";

import type { TimeRange } from "../../../../../../app/state/view/timeline/TimeRange";
import type { Spec as ChartSpec } from "../../../../../../components/widget-form/spec";
import { ChartWidget } from "../../../../../../components/widget-form/widget";

export interface PinnedMetricComponent {
	identifier: string;
	type: string;
	name: string;
}

export interface PinnedMetric {
	name?: string;
	description?: string;
	component: PinnedMetricComponent;
	chart: ChartSpec;
	metricQueries: ReadonlyArray<MetricQuery>;
}

export interface MetricProps {
	timeRange: Signal<TimeRange>;
	metric: PinnedMetric;
	markerTimestamp?: Time;
}

export const Metric: React.FC<MetricProps> = ({ timeRange, markerTimestamp, metric }) => {
	const timeRangeValue = useComputed(timeRange);

	return (
		<ChartWidget
			batch={metric.name ?? false}
			chart={metric.chart}
			onTimeRangeChange={(nextTimeRange) => timeRange.write(nextTimeRange)}
			queries={metric.metricQueries}
			timeRange={timeRangeValue}
			timestamp={markerTimestamp}
		/>
	);
};
